import _get from 'lodash/get';

import {USER_ROLES as roles} from '../../constants';

export function isSuperAdmin(operator) {
  const role = _get(operator, 'role', null);
  return role === roles.SUPER_ADMIN || role === roles.OEM_SUPER_ADMIN;
}
